import { Component } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { Router } from "@angular/router";

@Component({
  selector: "app-resultado-carpeta",
  templateUrl: "./resultado-carpeta.component.html",
  styleUrls: ["./resultado-carpeta.component.scss"],
})
export class ResultadoCarpetaComponent {

  public pageNumber: number = 1;
  public page_size: number = 3;
  public total_pages: number = 0;
  public arrayTotal: any[] = [];
  public activePage: boolean = false;
  public respuesta: string;
  public dataRes: any;

  constructor(
    private router: Router,
  ) {
    this.respuesta = this.router.getCurrentNavigation()?.extras.state?.["respuesta"];
  }

  ngOnInit() {    
    this.dataRes = this.respuesta ? JSON.parse(this.respuesta) : [];
    this.totalPages();
  }

  onPageChange(e: PageEvent): void {
    this.page_size = e.pageSize;
    this.pageNumber = e.pageIndex + 1;
  }
  
  private totalPages(): void {
    this.total_pages = this.dataRes.rows.length;
    if (this.total_pages > 1 && this.total_pages > 10) {
      this.arrayTotal = new Array(Math.round(10));
      this.activePage = true;
    } else {
      this.arrayTotal = new Array(Math.round(this.total_pages));
    }
  }

  goToBusqueda() {
    this.router.navigate(['/busqueda-carpetas']);
  }
}
